import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Container, ThemeProvider, StyledEngineProvider } from '@mui/material';
import MaterialTable from 'material-table';
import api from '../../../services/api';
import CircularProgress from '@mui/material/CircularProgress';
import tableTheme from '../../../components/Theme';
import FabButton from '../../../components/Buttons/FabButton';

function WaterSources() {
  const [waters, setWaters] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const history = useHistory();

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/water-sources');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setWaters(response.data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, []);

  const handleClick = (id) => {
    history.push(`/water/${id}`);
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={tableTheme}>
        <Container>
          <br />
          <MaterialTable
            title="Fontes de Água"
            columns={[
              {
                title: 'Nome',
                field: 'name',
                hideFilterIcon: true,
              },
              {
                title: 'Tipo',
                field: 'type',
                hideFilterIcon: true,
              },
            ]}
            data={waters}

            editable={{
              onRowUpdate: (newData, oldData) => new Promise((resolve, reject) => {
                setTimeout(() => {
                  const dataUpdate = [...waters];

                  const index = oldData.tableData.id;

                  dataUpdate[index] = newData;

                  setWaters(dataUpdate);
                  api.put(`/waters/${oldData.id}`, { ...newData });
                  resolve();
                }, 1000);
              }),
            }}
            localization={{
              header: {
                actions: '',
              },
              body: {
                emptyDataSourceMessage: <>{openProgress ? 'Nenhum registro para exibir' : <CircularProgress />}</>,
                filterRow: {
                  filterTooltip: 'Filtro',
                },
              },
              toolbar: {
                searchTooltip: 'Pesquisar',
                searchPlaceholder: 'Pesquisar',
                exportTitle: 'Exportar',
                exportCSVName: 'Exportar como CSV',
                exportPDFName: 'Exportar como PDF',

              },
              pagination: {
                labelRowsSelect: 'linhas',
                labelDisplayedRows: '{count} de {from}-{to}',
                firstTooltip: 'Primeira página',
                previousTooltip: 'Página anterior',
                nextTooltip: 'Próxima página',
                lastTooltip: 'Última página',
              },
            }}
            options={{
              filtering: true,
              exportButton: true,
              search: true,
              pageSize: 10,
              pageSizeOptions: [10, 15, 20, 50, 100],
              sorting: true,
            }}
            onRowClick={(evt, rowData) => handleClick(rowData.id)}
          />
          <div>
            <Container>
              <FabButton to="/water-source" />
            </Container>
          </div>
          <br />
        </Container>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default WaterSources;
